import useLoading from 'hooks/useLoading';
import useSosStatuses from 'hooks/useSosStatuses';
import React, { useRef } from 'react'
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend, PieChart, Pie, Cell } from 'recharts';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import CustomTitle from 'components/CustomTitle';
import ButtonIcon from 'components/ButtonComp';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import useSosStats from 'hooks/useSosStats';
import { ISosStats } from 'models/Cdr';

const Charts: React.FC = () => {
    const hookLoading = useLoading({ defaultLoading: false });
    const chartRef = useRef<HTMLDivElement>(null);
    const hookSosStats = useSosStats({});

    // Formatea la fecha y convierte los valores numéricos que están como string
    const formattedData = hookSosStats.data.map((item: ISosStats) => ({
        ...item,
        date: new Date(item.date).toLocaleDateString('es-ES'),
        answered_calls: parseInt(item.answered_calls),
        no_answer_calls: parseInt(item.no_answer_calls),
        busy_calls: parseInt(item.busy_calls),
        avg_duration: parseFloat(item.avg_duration),
        total_duration: parseInt(item.total_duration)
    }));

    // Sumar totales de llamadas atendidas y no atendidas
    const totalAnswered = formattedData.reduce((acc, item) => acc + (item.answered_calls || 0), 0);
    const totalNoAnswered = formattedData.reduce((acc, item) => acc + (item.no_answer_calls || 0), 0);

    const pieData = [
        { name: 'Contestadas', value: totalAnswered },
        { name: 'No contestadas', value: totalNoAnswered }
    ];

    const handleDownloadPDF = async () => {
        hookLoading.start();
        if (chartRef.current) {
            const canvas = await html2canvas(chartRef.current);
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('landscape', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 30;

            pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
            pdf.save(`sos_${new Date().getTime()}.pdf`);
        }
        hookLoading.end();
    };
    return (<>
        <CustomTitle
            className="mb-4"
            actions={[
                <ButtonIcon key="download" name="Descargar" icon={faFilePdf} variant="danger" onClick={handleDownloadPDF} disabled={hookLoading.isLoading} />
            ]}
        />
        <ResponsiveContainer width="100%" height={400} ref={chartRef}>
            <PieChart>
                <Tooltip />
                <Legend />
                <Pie
                    data={pieData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    label
                >
                    <Cell key="cell-contestadas" fill="#4CAF50" />
                    <Cell key="cell-no-contestadas" fill="#FF9800" />
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    </>
    )
}

export default Charts